import { DATA_GRID_LAZY_PAGE_SIZE } from '@/components/DataGrid/definitions';
import { api } from '@/services/api';
import { useDataGridFetcher } from '@/hooks/api/useDataGridFetcher';
import { PART_FINDER_REPORTS_QUERY_KEY } from '@/hooks/api/part-finder-reports/query';
import { useTenants } from '@/services/tenants/useTenants';

export const useListBatchReports = (batchId: string) => {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();

  return useDataGridFetcher({
    queryKey: parameters => [
      PART_FINDER_REPORTS_QUERY_KEY,
      {
        tenantId,
        batchId,
        page: +(parameters?.page ?? 1),
        perPage: +(parameters?.perPage ?? DATA_GRID_LAZY_PAGE_SIZE),
      },
    ],
    queryFn: parameters => () =>
      api.tenants.listPartFinderReports(
        tenantId,
        +(parameters?.page ?? 1),
        +(parameters?.perPage ?? DATA_GRID_LAZY_PAGE_SIZE),
        batchId
      ),
  });
};
